<template>
    <div class="relative flex shadow gap-1 h-10 pr-3 pl-3 justify-between items-center">
        <div class="flex items-center gap-1">
            <div class="bg-transparent md:hidden flex items-center" @click="isDrawerOpen = true">
                <span class="text-2xl material-symbols-outlined">menu</span>
            </div>
            <div class="flex items-center gap-1">
                <span>Call Center</span>
                <a-tag color="green" v-if="$store.getters.isSuperAdmin">Super</a-tag>
            </div>
        </div>
        <div class="flex items-center gap-4" :class="isDrawerOpen ? 'z-0' : 'z-10'">
            <ChangeLanguageBox class="flex items-center" />
            <MyConsoleBox />
        </div>

        <div v-show="isDrawerOpen" class="fixed inset-0 flex z-50">
            <div class="z-40 w-2/3 h-full text-white bg-[#091524] overflow-y-auto">
                <MenuBox />
            </div>
            <div class="fixed inset-0 bg-black/20" @click="isDrawerOpen = false"></div>
        </div>
    </div>
</template>

<script>
import ChangeLanguageBox from './change-language-box.vue';
import MenuBox from '@/components/menu-box.vue'
import MyConsoleBox from '@/components/my-console-box.vue'
import { mapGetters } from 'vuex';
export default {
    name: "AdminTopBox",
    components: {
        MenuBox,
        ChangeLanguageBox,
        MyConsoleBox
    },
    computed: {
        ...mapGetters({
            hasLogin: 'hasLogin',
            userInfo: 'userInfo'
        })
    },
    data() {
        return {
            isDrawerOpen: false
        }
    },
    methods: {
        onSignOUt() {
            this.$store.commit('signOut')
        }
    },
}
</script>
